export default __webpack_public_path__ + "static/media/draw_Freedraw_sele.4fd6f9ad.svg";